// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".double-input[data-v-0db845ee]{max-width:284px;margin:0 5px}", "",{"version":3,"sources":["webpack://./app/vue/components/checkouts/webstore/FirstnameLastname.vue"],"names":[],"mappings":"AAKA,+BACI,eAAA,CACA,YAAA","sourcesContent":["\n\n\n\n\n.double-input {\n    max-width: 284px;\n    margin: 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
